import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { faBars } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';
import { useAudioController } from '@store/audio/AudioController';

export const QueueButton = ({
  isQueueOpen,
  setQueueOpen,
}: {
  isQueueOpen: boolean;
  setQueueOpen: (open: boolean) => void;
}) => {
  const { disableNextPrev, queueTrackIds } = useAudioController();

  return (
    <IconButton
      variant={isQueueOpen ? 'inverted' : 'primary'}
      className={clsx(
        'data-[state=active]:text-fuchsia500',
        isQueueOpen && '!rounded-sm !bg-neutral800',
      )}
      onClick={() => {
        setQueueOpen(!isQueueOpen);
      }}
      icon={<FontAwesomeIcon icon={faBars} />}
      data-state={queueTrackIds.length > 0 ? 'active' : 'inactive'}
      disabled={disableNextPrev}
      title="Open queue"
      iconSize={16}
      size={30}
    />
  );
};
